import { Device, MonitoringSource } from "@services/devices/types";

export const has3rdPartyManagement = (device: Device) =>
  device.monitoringSources?.some(
    (source) => source === MonitoringSource._3rdPartyManagement
  ) ?? false;

export const hasRoomController = (device: Device) =>
  device.monitoringSources?.some(
    (source) => source === MonitoringSource.RoomController
  ) ?? false;

export const hasDMCA = (device: Device) =>
  device.monitoringSources?.some(
    (source) => source === MonitoringSource.AVISPLMonitoringAgent
  ) ?? false;

export const hasCommProxy = (device: Device) =>
  device.monitoringSources?.some(
    (source) => source === MonitoringSource.CommProxy
  ) ?? false;
